<template>
  <div class="files" :style="{ 'justify-content': align === 'right' ? 'flex-end' : 'flex-start' }">
    <a
      class="file"
      v-for="(it, index) in files"
      :key="index"
      :href="`/chats/media/${it.id}`"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img class="file__img" v-if="isImage(it)" :src="`/chats/media/${it.id}`" :alt="it.name || 'Вложение'" />
      <template v-else>
        <span class="file__ext">{{ ext(it) }}</span>
        <span class="file__size">{{ size(it) }}</span>
      </template>
    </a>
  </div>
</template>

<script>
export default {
  name: 'Files',
  props: {
    files: { type: Array, required: true, default: () => [] },
    align: { type: String, default: 'left' },
  },
  methods: {
    isImage(file) {
      return typeof file.type === 'string' && file.type.indexOf('image/') === 0;
    },
    ext(file) {
      const parts = String(file.name || '').split('.');
      return parts.length > 1 ? parts[parts.length - 1].toUpperCase().slice(0, 5) : 'ФАЙЛ';
    },
    size(file) {
      const bytes = Number(file.size) || 0;
      if (bytes < 1024) return `${bytes} Б`;
      if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} КБ`;
      return `${(bytes / 1024 / 1024).toFixed(1)} МБ`;
    },
  },
};
</script>

<style scoped>
.files {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.file {
  width: 96px;
  height: 96px;
  border: 1px solid var(--border, #d3e9f2);
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  background: var(--surface-2, #e9f8ff);
  color: var(--text-muted, #5c5c5c);
}

.file__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.file__ext {
  font-weight: 700;
  font-size: 13px;
  color: var(--accent, #0b89ac);
}

.file__size {
  font-size: 12px;
  margin-top: 2px;
}
</style>
